(() => {
 function init(header) {
  if(header.dataset.fitReady)return;header.dataset.fitReady='true';
  const nav=header.querySelector('.header__inline-menu'),list=nav?.querySelector('.list-menu--inline'),logo=header.querySelector('.header__heading')||header.querySelector('.header__heading-link'),icons=header.querySelector('.header__icons');
  if(!list||!logo||!icons)return;
  let frame=0,menuWidth=0;
  function measure(){
   cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>{
    if(innerWidth<990){header.classList.remove('lise-menu-overflow');return;}
    const h=header.getBoundingClientRect(),a=logo.getBoundingClientRect(),b=icons.getBoundingClientRect(),style=getComputedStyle(header);
    // Read layout first, then apply one class change; no geometry reads after the write.
    if(!header.classList.contains('lise-menu-overflow'))menuWidth=list.getBoundingClientRect().width;
    const available=h.width-parseFloat(style.paddingLeft)-parseFloat(style.paddingRight)-a.width-b.width-40;
    header.classList.toggle('lise-menu-overflow',menuWidth>available);
   });
  }
  if('ResizeObserver' in window)new ResizeObserver(measure).observe(header);else addEventListener('resize',measure,{passive:true});
  if(document.fonts)document.fonts.ready.then(()=>{header.classList.remove('lise-menu-overflow');measure();});
  measure();
 }
 const scan=()=>document.querySelectorAll('.section-header .header').forEach(init);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
 document.addEventListener('shopify:section:load',scan);
})();
